import { render } from "./Lottery.vue?vue&type=template&id=1a06ed78&scoped=true"
import script from "./Lottery.vue?vue&type=script&lang=js"
export * from "./Lottery.vue?vue&type=script&lang=js"

import "./Lottery.vue?vue&type=style&index=0&id=1a06ed78&scoped=true&lang=css"

import exportComponent from "D:\\Work\\renny\\rotto-sale\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a06ed78"]])

export default __exports__